import { refs, domReady, booleanDataset } from '../modules/utils.js';

class MoonBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const index = parseInt(newValue, 10);
      if (index >= 0) {
        this.refs.icons?.forEach((el, i) => booleanDataset(el, 'active', i === index));
      }
    }
  }

  async connectedCallback() {
    if (this.disconnected) return;

    await domReady();
    this.refs = refs(this);
    this.refs.editboxes = Array.from(document.querySelectorAll('.editbox1'));

    this.#listeners();

    this.parentElement.replaceWith(this);
  }

  disconnectedCallback() {
    this.disconnected = true;
  }

  #listeners() {
    this.refs.icons?.forEach((el) => {
      el.addEventListener('click', () => {
        if (el.hasAttribute('data-index')) {
          const section = document.querySelector(`.layout-content > *:nth-child(${el.getAttribute('data-index')})`);
          if (section) {
            const top = section.getBoundingClientRect().top + window.pageYOffset - this.offsetHeight;
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }
        } else {
          const index = Array.from(this.refs.icons).indexOf(el);
          if (this.refs.editboxes[index]) {
            const element = this.refs.editboxes[index].parentElement;
            // element.style.position = 'relative';
            const top = element.getBoundingClientRect().top + window.pageYOffset - this.offsetHeight;
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }
        }
      });
    });

    let customIndexes = false;
    const intersectingElements = [];
    const sections = document.querySelectorAll('.layout-content > *');
    let indexedSections = [];

    if (this.refs.icons?.[0].hasAttribute('data-index')) {
      customIndexes = true;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target;
        if (entry.isIntersecting && !intersectingElements.includes(target)) {
          intersectingElements.push(target);
        }
        if (!entry.isIntersecting && intersectingElements.includes(target)) {
          intersectingElements.splice(intersectingElements.indexOf(target), 1);
        }
        if (intersectingElements.length) {
          if (customIndexes) {
            this.dataset.index = indexedSections.indexOf(intersectingElements[intersectingElements.length - 1]);
          } else {
            this.dataset.index = this.refs.editboxes.indexOf(intersectingElements[intersectingElements.length - 1]);
          }
        }
      });
    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    if (customIndexes) {
      this.refs.icons.forEach(el => {
        const index = parseInt(el.getAttribute('data-index'), 10);
        if (sections[index]) {
          indexedSections.push(sections[index]);
          observer.observe(sections[index]);
        }
      });
    }
    else {
      this.refs.editboxes.forEach(editbox => {
        observer.observe(editbox);
      });
    }
  }
}

customElements.define('moon-bar', MoonBar);
